import { observable, action, runInAction } from 'mobx';
import { MDialog } from '@weapp/ui';
import { mBindParams } from './type';
import * as API from "../../../api/m/bind";
import { setCookie, inApp, mainHost, setTokenStorage, setAreaCodeStorage, setAccountStorage, getQueryString, setAutoPswStorage } from '../../../utils';
import { getLabel, WeappSDK, weappSDK } from '@weapp/utils';
import { publicUrl } from "../../../constants";
const { toast } = MDialog;

export class mAccountBindStore {

    @observable loginBoxVisible: boolean = false;//已登录账号显示人员信息还是输入框
    @observable key: string = ''//邀请Key
    routeTo: any = null;

    @action
    init = (routeTo: any) => {
        this.routeTo = routeTo;
        this.key = getQueryString('key') || '';
        if (getQueryString('token')) {
            setTokenStorage(getQueryString('token'));
        }
    }
    //绑定已有账号
    @action
    bindExistAccount = (params: mBindParams) => {
        API.bindExistAccount(params).then((result: any) => {
            if (result?.data?.errorMsg) {
                const msg = result.data.errorMsg
                toast({
                    type: "fail",
                    content: getLabel(msg.i18nId, msg.msg)
                });
            } else {
                if (result.data?.loginResult?.redirectUrl) {
                    window.location.href = result.data.loginResult.redirectUrl;
                }
                if (!result.data?.loginResult?.hasTenant) {
                    setTokenStorage(result.data.userIdToken);
                    setAreaCodeStorage(null);
                    setAccountStorage(params.account);
                    this.routeTo(`${publicUrl}/signup/tenant`);
                }
            }
        });
    }

    //创建随机账号
    @action
    createRandomAccount = () => {
        const params = {
            key: this.key
        }
        API.createRandomAccount(params).then((result: any) => {
            if (result?.data?.errorMsg) {
                const msg = result.data.errorMsg
                toast({
                    type: "fail",
                    content: getLabel(msg.i18nId, msg.msg)
                });
            } else {
                if (result.data?.loginResult?.hasTenant) {

                } else {
                    setTokenStorage(result.data.userIdToken);
                    setAreaCodeStorage(null);
                    setAccountStorage(result.data?.userInfo?.account);
                    setAutoPswStorage(result.data?.userInfo?.password);
                    this.routeTo(`${publicUrl}/signup/tenant?bind=true`);
                }
            }
        });
    }

}

const instance = new mAccountBindStore();
export type mAccountBindStoreType = Pick<mAccountBindStore, keyof mAccountBindStore>;
export default instance;
